import { render, staticRenderFns } from "./InvitationOverview.vue?vue&type=template&id=60dd64f1&scoped=true&"
import script from "./InvitationOverview.vue?vue&type=script&lang=js&"
export * from "./InvitationOverview.vue?vue&type=script&lang=js&"
import style0 from "./InvitationOverview.vue?vue&type=style&index=0&id=60dd64f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dd64f1",
  null
  
)

export default component.exports